import { moment } from "./moment";

type FormattableKey = "createdAt" | "updatedAt";
type FormattableObject = {
	[key in FormattableKey]: string | null;
};

/**
 * This is a function that formats the createdAt or updatedAt field of an object to a human-readable format.
 * @param item
 * @param key
 * @returns
 */
function tableFormatter<
	T extends Pick<FormattableObject, "createdAt"> | Pick<FormattableObject, "updatedAt">,
>(item: T, key: FormattableKey): string {
	const date = item[key as keyof T];
	if (date === null) return "";
	return moment(date).longFormat();
}

/**
 * This function formats the updatedAt field of an object to a human-readable format.
 * @param item
 * @returns
 */
export function updatedAtFormatter<T extends Pick<FormattableObject, "updatedAt">>(
	item: T,
): string {
	return tableFormatter(item, "updatedAt");
}

/**
 * This function formats the createdAt field of an object to a human-readable format.
 * @param item
 * @returns
 */
export function createdAtFormatter<T extends Pick<FormattableObject, "createdAt">>(
	item: T,
): string {
	return tableFormatter(item, "createdAt");
}
